<template>
    <div class="auto-reply">
        <div class="search-section">
            <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                <el-form-item label="关键词">
                    <el-input v-model="searchForm.keyword" placeholder="请输入关键词搜索" clearable size="large"
                        style="width: 200px">
                    </el-input>
                </el-form-item>

                <el-form-item label="条件类型">
                    <el-select v-model="searchForm.ruletype" placeholder="请选择条件类型" clearable size="large"
                        style="width: 150px">
                        <el-option label="等于" :value="0" />
                        <el-option label="包含" :value="1" />
                        <el-option label="正则匹配" :value="2" />
                    </el-select>
                </el-form-item>

                <el-form-item label="回复类型">
                    <el-select v-model="searchForm.replaytype" placeholder="请选择回复类型" clearable size="large"
                        style="width: 150px">
                        <el-option label="文本" :value="0" />
                        <el-option label="图片" :value="1" />
                        <el-option label="视频" :value="2" />
                    </el-select>
                </el-form-item>

                <el-form-item label="状态">
                    <el-select v-model="searchForm.status" placeholder="请选择状态" clearable size="large"
                        style="width: 120px">
                        <el-option label="启用" :value="1" />
                        <el-option label="禁用" :value="0" />
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <div class="button-group">
                        <el-button type="primary" @click="onSearch" size="large">
                            <el-icon>
                                <Search />
                            </el-icon>
                            搜索
                        </el-button>
                        <el-button @click="resetSearch" size="large">
                            <el-icon>
                                <Refresh />
                            </el-icon>
                            重置
                        </el-button>
                        <el-button type="success" @click="showCreateDialog" size="large">
                            <el-icon>
                                <Plus />
                            </el-icon>
                            新增规则
                        </el-button>
                        <el-button type="warning" @click="handleImport" size="large">
                            <el-icon>
                                <Upload />
                            </el-icon>
                            导入
                        </el-button>
                        <!-- <el-button type="info" @click="handleExport" size="large">
                            <el-icon>
                                <Download />
                            </el-icon>
                            导出
                        </el-button> -->
                    </div>
                </el-form-item>
            </el-form>
        </div>



        <el-divider></el-divider>

        <!-- 数据表格 -->
        <el-table :data="tableData" style="width: 100%" v-loading="loading">

            <el-table-column label="触发条件" min-width="250">
                <template #default="scope">
                    <el-text>{{ getRuleDescription(scope.row) }}</el-text>
                </template>
            </el-table-column>


            <el-table-column label="回复类型" min-width="80">
                <template #default="scope">
                    <el-tag type="primary" size="small">{{ scope.row.replaytype === 0 ? '文本' : scope.row.replaytype ===
                        1 ? '图片' : '视频' }}</el-tag>
                </template>
            </el-table-column>



            <!-- 渲染  是否回复管理员  -->
            <el-table-column label="是否回复管理员" width="120">
                <template #default="scope">
                    <el-tag :type="scope.row.noreply2admin === 1 ? 'success' : 'info'" size="small">{{
                        scope.row.noreply2admin === 1 ? '是' : '否' }}</el-tag>
                </template>
            </el-table-column>

            <el-table-column label="删除回复信息" width="120">
                <template #default="scope">
                    <el-tag :type="getDelReplyMsgType(scope.row.delreplymsg)" size="small">{{
                        getDelReplyMsgText(scope.row.delreplymsg) }}</el-tag>
                </template>
            </el-table-column>




            <el-table-column prop="status" label="状态" width="100">
                <template #default="scope">
                    <el-switch v-model="scope.row.status" :active-value="1" :inactive-value="0"
                        @change="handleStatusChange(scope.row)">
                    </el-switch>
                </template>
            </el-table-column>

            <el-table-column prop="remark" label="备注" width="150" show-overflow-tooltip />

            <el-table-column label="操作" width="280" fixed="right">
                <template #default="scope">
                    <el-button type="success" size="small" @click="handlePreview(scope.row)">
                        <el-icon>
                            <ViewIcon />
                        </el-icon>
                        预览
                    </el-button>
                    <el-button type="primary" size="small" @click="handleEdit(scope.row)">
                        <el-icon>
                            <Edit />
                        </el-icon>
                        编辑
                    </el-button>
                    <el-button type="danger" size="small" @click="handleDelete(scope.row)">
                        <el-icon>
                            <Delete />
                        </el-icon>
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <div class="pagination">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>

        <!-- 新增/编辑对话框 -->
        <el-dialog v-model="dialogVisible" :title="dialogType === 'create' ? '新增自动回复规则' : '编辑自动回复规则'" width="900px"
            :close-on-click-modal="false" destroy-on-close>
            <el-form ref="formRef" :model="form" :rules="rules" label-width="140px" label-position="right"
                class="auto-reply-form">

                <!-- 条件 -->
                <el-form-item prop="keywords" label-width="10px">

                    <div class="condition-input-group">
                        <span style="white-space: nowrap; margin-right: 10px;">当消息内容</span>
                        <el-select v-model="form.ruletype" style="width: 120px; flex-shrink: 0;">
                            <el-option label="等于" :value="0"></el-option>
                            <el-option label="包含" :value="1"></el-option>
                            <el-option label="正则匹配" :value="2"></el-option>
                        </el-select>
                        <div class="keyword-tags-input">
                            <el-tag v-for="tag in form.keywords" :key="tag" closable :disable-transitions="false"
                                @close="handleKeywordTagClose(tag)">
                                {{ tag }}
                            </el-tag>
                            <input type="text" class="keyword-new-tag-input" v-model="form.keyword_input"
                                @keyup.enter="handleKeywordInputConfirm" placeholder="输入后按回车" />
                        </div>
                    </div>
                </el-form-item>

                <!-- 自动回复类型 -->
                <el-form-item prop="replaytype" label-width="10px">
                    <div class="reply-type-horizontal">
                        <div class="type-select-container">
                            <span style="white-space: nowrap; margin-right: 10px;">自动回复类型</span>
                            <el-select v-model="form.replaytype" placeholder="请选择回复类型" style="width: 150px;"
                                popper-class="reply-type-dropdown">
                                <el-option label="文本内容" :value="0"></el-option>
                                <el-option label="图片" :value="1"></el-option>
                                <el-option label="视频" :value="2"></el-option>
                                <el-option label="音频" :value="3"></el-option>
                            </el-select>
                        </div>
                        <div class="media-url-container" v-if="[1, 2, 3].includes(form.replaytype)">
                            <span style="white-space: nowrap; margin-right: 10px; color: #606266; font-size: 14px;">
                                {{ { 1: '图片', 2: '视频', 3: '音频' }[form.replaytype] }}地址：
                            </span>
                            <el-input v-model="form.mediaurl"
                                :placeholder="`请输入${{ 1: '图片', 2: '视频', 3: '音频' }[form.replaytype]}的URL地址`"
                                style="flex: 1; min-width: 200px;" />
                        </div>
                    </div>
                </el-form-item>

                <el-form-item prop="replaytext" label="自动回复文本" label-width="120px">
                    <div class="html-editor">
                        <!-- 简单的 HTML 工具栏 -->
                        <div class="html-toolbar">
                            <button @click="insertHtml('<b>', '</b>')" type="button" title="加粗">
                                <strong>B</strong>
                            </button>
                            <button @click="insertHtml('<i>', '</i>')" type="button" title="斜体">
                                <em>I</em>
                            </button>
                            <button @click="insertHtml('<u>', '</u>')" type="button" title="下划线">
                                <u>U</u>
                            </button>
                            <button @click="insertHtml('<br>')" type="button" title="换行">
                                换行
                            </button>
                            <span class="divider">|</span>
                            <button @click="insertHtml('<h1>', '</h1>')" type="button" title="标题1">
                                H1
                            </button>
                            <button @click="insertHtml('<h2>', '</h2>')" type="button" title="标题2">
                                H2
                            </button>
                            <span class="divider">|</span>
                            <button @click="insertHtml('<ul><li>', '</li></ul>')" type="button" title="无序列表">
                                • 列表
                            </button>
                            <button @click="insertHtml('<ol><li>', '</li></ol>')" type="button" title="有序列表">
                                1. 列表
                            </button>
                            <span class="divider">|</span>
                            <button @click="toggleMode" type="button" :title="isSourceMode ? '切换到可视化模式' : '切换到源码模式'"
                                :class="{ 'is-active': isSourceMode }">
                                {{ isSourceMode ? '可视' : '源码' }}
                            </button>
                        </div>
                        <!-- 编辑器内容区域 -->
                        <div class="editor-content-area">
                            <!-- 可视化编辑模式 -->
                            <div v-if="!isSourceMode" ref="visualEditor" class="visual-editor" contenteditable="true"
                                @input="handleVisualInput" @compositionstart="handleCompositionStart"
                                @compositionend="handleCompositionEnd" @paste="handlePaste" @keydown="handleKeydown">
                            </div>
                            <!-- 源码编辑模式 -->
                            <el-input v-if="isSourceMode" ref="htmlTextarea" v-model="form.replaytext" type="textarea"
                                :rows="8" placeholder="请输入回复内容，支持HTML标签..." class="html-textarea" />
                        </div>
                    </div>
                </el-form-item>

                <!-- 变量说明 -->
                <div class="variable-help-text">
                    <span class="variable-item"><code>{member}</code>为带链接群成员名字，</span>
                    <span class="variable-item"><code>{userId}</code>为用户ID，</span>
                    <span class="variable-item"><code>{nickname}</code>为用户昵称，</span>
                    <span class="variable-item"><code>{userName}</code>为用户名，</span>
                    <span class="variable-item"><code>{pointAlias}</code>为积分别名，</span>
                    <span class="variable-item"><code>{pointBalance}</code>为积分余额，</span>
                    <span class="variable-item"><code>{pointRank}</code>表示用户积分排名，</span>
                    <span class="variable-item"><code>{levelName}</code>为群成员等级，</span>
                    <span class="variable-item"><code>{currentTime}</code>为当前时间，</span>
                    <span class="variable-item"><code>{groupTitle}</code>为群名称</span>
                </div>

                <!-- 附加按钮 -->
                <el-form-item prop="buttons" label="附加按钮" label-width="80px">
                    <!-- 按钮行列表 -->
                    <div v-if="form.buttons.length > 0" class="button-rows-list">
                        <div v-for="(row, rowIndex) in form.buttons" :key="`row-${rowIndex}-${JSON.stringify(row)}`"
                            class="button-row-wrapper" @dragover="handleDragOver" @drop="handleDrop($event, rowIndex)"
                            :class="{ 'drag-over': draggedRowIndex !== null && draggedRowIndex !== rowIndex }">
                            <!-- 灰色按钮容器 -->
                            <div class="gray-buttons-container">
                                <div v-for="(button, btnIndex) in row" :key="btnIndex" class="button-item">
                                    {{ button.text || '按钮' }}
                                    <div class="button-actions">
                                        <div class="button-action-icon edit-icon"
                                            @click="editButton(rowIndex, btnIndex)" title="编辑按钮">
                                            <el-icon>
                                                <Edit />
                                            </el-icon>
                                        </div>
                                        <div class="button-action-icon delete-icon"
                                            @click="removeButton(rowIndex, btnIndex)" title="删除按钮">
                                            <el-icon>
                                                <Delete />
                                            </el-icon>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- 只有当行数 >= 1 时，才显示"本行新增一个按钮" -->
                            <div v-if="form.buttons.length >= 1" class="add-button-container">
                                <button @click="showAddButtonDialog(rowIndex)" type="button" class="add-to-row-button">
                                    + 本行新增一个按钮
                                </button>
                            </div>
                            <!-- 右侧拖拽图标 -->
                            <div class="drag-icon-container" :title="'拖拽移动第' + (rowIndex + 1) + '行'" draggable="true"
                                @dragstart="handleDragStart(rowIndex)" @dragend="handleDragEnd">
                                <el-icon class="drag-icon">
                                    <Rank />
                                </el-icon>
                            </div>
                        </div>
                    </div>

                    <!-- 新增一行按钮 -->
                    <div class="button-controls">
                        <button @click="showAddButtonDialog(-1)" type="button" class="add-row-button">
                            + 新增一行按钮
                        </button>
                    </div>
                </el-form-item>

                <!-- 添加按钮对话框 -->
                <el-dialog v-model="buttonDialogVisible" :title="getDialogTitle()" width="400px"
                    :close-on-click-modal="false" destroy-on-close>
                    <el-form :model="buttonForm" :rules="buttonRules" ref="buttonFormRef" label-width="80px">
                        <el-form-item label="按钮文字" prop="text">
                            <el-input v-model="buttonForm.text" placeholder="请输入按钮文字" />
                        </el-form-item>
                        <el-form-item label="链接" prop="url">
                            <el-input v-model="buttonForm.url" placeholder="请输入http://或https://开头的链接地址" />
                        </el-form-item>
                    </el-form>
                    <template #footer>
                        <div class="dialog-footer">
                            <el-button @click="buttonDialogVisible = false">取消</el-button>
                            <el-button type="primary" @click="confirmAddButton">确定</el-button>
                        </div>
                    </template>
                </el-dialog>

                <!-- 其他设置 -->
                <el-form-item prop="noreply2admin" label-width="120px">
                    <template #label>
                        <span class="form-label-with-icon">
                            回复管理员消息
                        </span>
                    </template>
                    <el-switch v-model="form.noreply2admin" :active-value="1" :inactive-value="0"></el-switch>
                </el-form-item>

                <el-form-item prop="quoteusermsg" label-width="120px">
                    <template #label>
                        <span class="form-label-with-icon">
                            引用用户消息
                        </span>
                    </template>
                    <el-switch v-model="form.quoteusermsg" :active-value="1" :inactive-value="0"></el-switch>
                </el-form-item>

                <el-form-item prop="deloriginalmsg" label-width="130px">
                    <template #label>
                        <span>删除用户原始消息</span>
                    </template>
                    <el-select v-model="form.deloriginalmsg" placeholder="不删除" style="max-width: 400px;">
                        <el-option label="不删除" :value="0"></el-option>
                        <el-option label="1秒后删除" :value="1"></el-option>
                        <el-option label="3秒后删除" :value="3"></el-option>
                        <el-option label="5秒后删除" :value="5"></el-option>
                        <el-option label="10秒后删除" :value="10"></el-option>
                        <el-option label="20秒后删除" :value="20"></el-option>
                        <el-option label="30秒后删除" :value="30"></el-option>
                        <el-option label="60秒后删除" :value="60"></el-option>
                        <el-option label="90秒后删除" :value="90"></el-option>
                        <el-option label="120秒后删除" :value="120"></el-option>

                        <el-option label="5分钟后删除" :value="300"></el-option>
                        <el-option label="10分钟后删除" :value="600"></el-option>
                        <el-option label="15分钟后删除" :value="900"></el-option>
                        <el-option label="30分钟后删除" :value="1800"></el-option>
                        <el-option label="60分钟后删除" :value="3600"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item prop="delreplymsg" label-width="140px">
                    <template #label>
                        <span>删除机器人回复消息</span>
                    </template>
                    <el-select v-model="form.delreplymsg" placeholder="不删除" style="max-width: 400px;">
                        <el-option label="删除上一条" :value="-1"></el-option>
                        <el-option label="不删除" :value="0"></el-option>
                        <el-option label="1秒后删除" :value="1"></el-option>
                        <el-option label="3秒后删除" :value="3"></el-option>
                        <el-option label="5秒后删除" :value="5"></el-option>
                        <el-option label="10秒后删除" :value="10"></el-option>
                        <el-option label="20秒后删除" :value="20"></el-option>
                        <el-option label="30秒后删除" :value="30"></el-option>
                        <el-option label="60秒后删除" :value="60"></el-option>
                        <el-option label="90秒后删除" :value="90"></el-option>
                        <el-option label="120秒后删除" :value="120"></el-option>

                        <el-option label="5分钟后删除" :value="300"></el-option>
                        <el-option label="10分钟后删除" :value="600"></el-option>
                        <el-option label="15分钟后删除" :value="900"></el-option>
                        <el-option label="30分钟后删除" :value="1800"></el-option>
                        <el-option label="60分钟后删除" :value="3600"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item prop="remark" label-width="100px" style="max-width: 500px;">
                    <template #label>
                        <span>个性化备注</span>
                    </template>
                    <el-input v-model="form.remark" placeholder="请输入个性化备注" />
                </el-form-item>

            </el-form>
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="dialogVisible = false">取消</el-button>
                    <el-button type="success" @click="handlePreviewtemplate">预览</el-button>
                    <el-button type="primary" @click="handleSubmit">确定</el-button>
                </div>
            </template>
        </el-dialog>

        <!-- 导入对话框 -->
        <el-dialog v-model="importVisible" title="导入自动回复规则" width="600px">
            <el-upload ref="uploadRef" class="upload-demo" drag action="#" :auto-upload="false"
                :on-change="handleFileChange" accept=".xlsx, .xls" :limit="1" :on-exceed="handleExceed">
                <el-icon class="el-icon--upload"><upload-filled /></el-icon>
                <div class="el-upload__text">
                    将文件拖到此处，或<em>点击上传</em>
                </div>
                <template #tip>
                    <div class="el-upload__tip">
                        仅支持 .xlsx, .xls 格式文件
                    </div>
                </template>
            </el-upload>
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="importVisible = false">取消</el-button>
                    <el-button type="primary" @click="confirmImport" :loading="importLoading" :disabled="!selectedFile">
                        {{ importLoading ? '正在导入...' : '确定导入' }}
                    </el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import { Search, Refresh, Plus, Edit, Delete, Upload, UploadFilled, Rank, View as ViewIcon } from '@element-plus/icons-vue'
import api from '@/services/api'
import * as XLSX from 'xlsx'

export default {
    name: 'AutoReply',
    components: {
        Search,
        Refresh,
        Plus,
        Edit,
        Delete,
        Upload,
        UploadFilled,
        Rank,
        ViewIcon
    },
    data() {
        return {
            searchForm: {
                keyword: '',
                ruletype: '',
                replaytype: '',
                status: '',
                dateRange: []
            },
            tableData: [],
            currentPage: 1,
            pageSize: 20,
            total: 0,
            loading: false,
            statsVisible: false,
            stats: {
                overview: null
            },
            dialogVisible: false,
            dialogType: 'create',
            importVisible: false,
            importLoading: false,
            selectedFile: null,
            currentUserInfo: {
                userid: null,
                groupid: null,
                userBot: null
            },
            form: {
                keyword: '',
                keywords: [],
                keyword_input: '',
                ruletype: 0,
                replaytype: 0,
                replaytext: '',
                mediaurl: '',
                buttons: [], // For dynamic buttons UI
                noreply2admin: 0,
                quoteusermsg: 1,
                deloriginalmsg: 0,
                delreplymsg: 0,
                remark: '',
                requiredpoints: 0,
                status: 1,
                userBot: null,
                groupid: null,
                userid: null
            },
            rules: {
                keywords: [
                    {
                        required: true,
                        validator: (rule, value, callback) => {

                            if (!value || !Array.isArray(value) || value.length === 0) {
                                callback(new Error('请至少添加一个触发关键词'));
                            } else {
                                callback();
                            }
                        },
                        trigger: ['blur', 'change']
                    }
                ],
                replaytext: [
                    {
                        required: true,
                        message: '请输入回复文本内容',
                        trigger: 'blur',
                        validator: (rule, value, callback) => {

                            if (!value || value.trim() === '') {
                                callback(new Error('请输入回复文本内容'));
                            } else {
                                callback();
                            }
                        }
                    }
                ]
            },
            isSourceMode: false,
            isComposing: false,
            shouldRestoreCaret: false,
            updateTimer: null,
            // 按钮对话框相关
            buttonDialogVisible: false,
            buttonForm: {
                text: '',
                url: ''
            },
            currentRowIndex: -1,
            editingButtonRowIndex: -1, // 正在编辑的按钮行索引
            editingButtonIndex: -1, // 正在编辑的按钮索引
            // 拖拽相关
            draggedRowIndex: null,
            buttonRules: {
                text: [
                    { required: true, message: '请输入按钮文字', trigger: 'blur' }
                ],
                url: [
                    { required: true, message: '请输入链接地址', trigger: 'blur' },
                    {
                        pattern: /^https?:\/\/.+/,
                        message: '链接地址必须以http://或https://开头',
                        trigger: 'blur'
                    }
                ]
            }
        }
    },
    computed: {
        vuexUser() {
            return this.$store.state.user;
        }
    },
    watch: {
        vuexUser: {
            handler(newUser) {
                if (newUser) {
                    this.loadUserInfo(newUser);
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        // 格式化删除回复消息的显示文本
        getDelReplyMsgText(delreplymsg) {
            if (delreplymsg === -1) {
                return '删除上一条';
            } else if (delreplymsg === 0) {
                return '不删除';
            } else if (delreplymsg > 0) {
                return delreplymsg + '秒后删除';
            } else {
                return '不删除';
            }
        },
        // 获取删除回复消息的标签颜色类型
        getDelReplyMsgType(delreplymsg) {
            if (delreplymsg === -1) {
                return 'danger';  // 红色 - 删除上一条
            } else if (delreplymsg === 0) {
                return 'info';    // 灰色 - 不删除
            } else if (delreplymsg > 0) {
                return 'danger'; // 橙色 - 定时删除
            } else {
                return 'info';    // 默认灰色
            }
        },
        loadUserInfo(user) {
            this.currentUserInfo.userId = user.userId;
            this.currentUserInfo.groupId = user.groupId;
            this.currentUserInfo.userBot = user.userBot;
        },
        onSearch() {
            this.currentPage = 1
            this.fetchData()
        },
        resetSearch() {
            this.searchForm = {
                keyword: '',
                ruletype: '',
                replaytype: '',
                status: '',
                dateRange: []
            }
            this.currentPage = 1
            this.fetchData()
        },
        async fetchData() {
            this.loading = true
            try {
                const params = {
                    page: this.currentPage,
                    pageSize: this.pageSize,
                    userBot: this.currentUserInfo.userBot,
                    groupid: this.currentUserInfo.groupId
                }

                if (this.searchForm.keyword) {
                    params.keyword = this.searchForm.keyword
                }
                if (this.searchForm.ruletype !== '') {
                    params.ruletype = this.searchForm.ruletype
                }
                if (this.searchForm.replaytype !== '') {
                    params.replaytype = this.searchForm.replaytype
                }
                if (this.searchForm.status !== '') {
                    params.status = this.searchForm.status
                }

                const response = await api.getAutoReplyRules(params)

                if (response.data.code === 0) {
                    this.tableData = response.data.data.records
                    this.total = response.data.data.total
                } else {
                    this.$message.error(response.data.message || '获取数据失败')
                }
            } catch (error) {
                console.error('获取自动回复规则失败:', error)
                this.$message.error('获取数据失败')
            } finally {
                this.loading = false
            }
        },
        async fetchStats() {
            try {
                this.loading = true
                const response = await api.getAutoReplyStats()

                if (response.data.code === 0) {
                    this.stats = response.data.data
                    this.statsVisible = true
                } else {
                    this.$message.error(response.data.message || '获取统计信息失败')
                }
            } catch (error) {
                console.error('获取统计信息失败:', error)
                this.$message.error('获取统计信息失败')
            } finally {
                this.loading = false
            }
        },
        handleSizeChange(val) {
            this.pageSize = val
            this.currentPage = 1
            this.fetchData()
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.fetchData()
        },
        showCreateDialog() {
            this.dialogType = 'create'
            this.form = {
                keyword: '',
                keywords: [],
                keyword_input: '',
                ruletype: 0,
                replaytype: 0,
                replaytext: '',
                mediaurl: '',
                buttons: [],
                noreply2admin: 0,
                quoteusermsg: 1,
                deloriginalmsg: 0,
                delreplymsg: 0,
                remark: '',
                requiredpoints: 0,
                status: 1
            }
            this.dialogVisible = true

            // 延迟清空编辑器内容，确保DOM已更新
            this.$nextTick(() => {
                this.setVisualEditorContent('');
            });
        },
        handleEdit(row) {
            this.dialogType = 'edit'
            this.form = { ...row }

            // 处理关键词数据：支持JSON数组和逗号分隔字符串两种格式
            if (row.keyword) {
                try {
                    // 尝试解析为JSON数组
                    if (typeof row.keyword === 'string' && row.keyword.startsWith('[')) {
                        this.form.keywords = JSON.parse(row.keyword)
                    } else if (Array.isArray(row.keyword)) {
                        // 已经是数组格式
                        this.form.keywords = row.keyword
                    } else {
                        // 逗号分隔的字符串格式
                        this.form.keywords = row.keyword.split(',').filter(k => k.trim())
                    }
                } catch (e) {
                    // JSON解析失败，按逗号分隔处理
                    this.form.keywords = row.keyword.split(',').filter(k => k.trim())
                }
            } else {
                this.form.keywords = []
            }

            this.form.keyword_input = ''
            if (!this.form.mediaurl) {
                this.form.mediaurl = ''
            }
            // 处理按钮数据：尝试JSON解析，失败则按文本格式解析
            try {
                this.form.buttons = JSON.parse(row.button || '[]')
            } catch (e) {
                // JSON解析失败，尝试按文本格式解析
                this.form.buttons = this.parseButtonData(row.button || '')
            }
            this.dialogVisible = true

            // 延迟设置编辑器内容，确保DOM已更新
            this.$nextTick(() => {
                this.setVisualEditorContent(this.form.replaytext);
            });
        },
        async handleDelete(row) {
            try {
                await this.$confirm('确定要删除这个自动回复规则吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })

                const response = await api.deleteAutoReplyRule(row.id, {
                    userBot: this.currentUserInfo.userBot,
                    groupid: this.currentUserInfo.groupId
                })
                if (response.data.code === 0) {
                    this.$message.success('删除成功')
                    this.fetchData()
                } else {
                    this.$message.error(response.data.message || '删除失败')
                }
            } catch (error) {
                if (error !== 'cancel') {
                    console.error('删除失败:', error)
                    this.$message.error('删除失败')
                }
            }
        },
        async handleStatusChange(row) {
            try {
                const response = await api.updateAutoReplyRule(row.id, {
                    status: row.status,
                    userBot: this.currentUserInfo.userBot,
                    groupid: this.currentUserInfo.groupId
                })
                if (response.data.code === 0) {
                    this.$message.success('状态更新成功')
                } else {
                    this.$message.error(response.data.message || '状态更新失败')
                    // 恢复原状态
                    row.status = row.status === 1 ? 0 : 1
                }
            } catch (error) {
                console.error('状态更新失败:', error)
                this.$message.error('状态更新失败')
                // 恢复原状态
                row.status = row.status === 1 ? 0 : 1
            }
        },
        async handleSubmit() {

            try {

                await this.$refs.formRef.validate();


                const finalForm = { ...this.form };


                // === 数据预处理：转换前端表单格式为后端存储格式 ===

                // 1. 关键词处理：数组 -> JSON数组格式（直接传数组，后端Sequelize自动处理）

                if (finalForm.keywords && finalForm.keywords.length > 0) {
                    finalForm.keyword = finalForm.keywords; // 直接传数组
                } else {
                    finalForm.keyword = []; // 空数组
                }
                delete finalForm.keywords;
                delete finalForm.keyword_input;


                // 2. 按钮处理：二维数组 -> 文本格式

                if (finalForm.buttons && finalForm.buttons.length > 0) {
                    // 转换格式：[[{text: '按钮1', url: 'url1'}, {text: '按钮2', url: 'url2'}]] 
                    // -> "按钮1(url1);按钮2(url2)\n按钮3(url3)"
                    const buttonText = finalForm.buttons.map(row =>
                        row.map(button => `${button.text}(${button.url})`).join(';')
                    ).join('\n');
                    finalForm.button = buttonText;
                } else {
                    finalForm.button = '';
                }
                delete finalForm.buttons;


                // 3. 数据验证

                if (!finalForm.keyword || finalForm.keyword.length === 0) {

                    this.$message.error('请至少添加一个触发关键词');
                    return;
                }
                if (!finalForm.replaytext || finalForm.replaytext.trim() === '') {

                    this.$message.error('请输入回复内容');
                    return;
                }


                // 4. 数值类型确保正确

                finalForm.ruletype = parseInt(finalForm.ruletype) || 0;
                finalForm.replaytype = parseInt(finalForm.replaytype) || 0;
                finalForm.noreply2admin = parseInt(finalForm.noreply2admin) || 0;
                finalForm.quoteusermsg = parseInt(finalForm.quoteusermsg) || 0;
                finalForm.deloriginalmsg = parseInt(finalForm.deloriginalmsg) || 0;
                finalForm.delreplymsg = parseInt(finalForm.delreplymsg) || 0;
                finalForm.requiredpoints = parseInt(finalForm.requiredpoints) || 0;
                finalForm.status = parseInt(finalForm.status) || 0;



                // 5. 空值处理
                if (!finalForm.mediaurl || finalForm.mediaurl.trim() === '') {
                    finalForm.mediaurl = null;
                }
                if (!finalForm.remark) {
                    finalForm.remark = '';
                }



                let response;
                if (this.dialogType === 'create') {


                    // 创建时，将当前用户信息附加到表单中
                    finalForm.userid = this.currentUserInfo.userId;
                    finalForm.groupid = this.currentUserInfo.groupId;
                    finalForm.userBot = this.currentUserInfo.userBot;


                    if (!finalForm.userid || !finalForm.groupid || !finalForm.userBot) {

                        this.$message.error('用户信息不完整，请刷新页面后重试');
                        return;
                    }


                    response = await api.createAutoReplyRule(finalForm);

                } else {

                    finalForm.groupid = this.currentUserInfo.groupId;
                    finalForm.userBot = this.currentUserInfo.userBot;

                    if (!finalForm.id) {

                        this.$message.error('规则ID丢失，请刷新页面后重试');
                        return;
                    }


                    response = await api.updateAutoReplyRule(finalForm.id, finalForm);

                }

                if (response.data.code === 0) {

                    this.$message.success(this.dialogType === 'create' ? '创建成功' : '更新成功');
                    this.dialogVisible = false;
                    this.fetchData();
                } else {

                    this.$message.error(response.data.message || '操作失败');
                }
            } catch (error) {
                console.error('=== handleSubmit 异常 ===');
                console.error('错误类型:', error.name);
                console.error('错误消息:', error.message);
                console.error('错误堆栈:', error.stack);
                if (error.response) {
                    console.error('HTTP响应错误:', JSON.stringify({
                        status: error.response.status,
                        statusText: error.response.statusText,
                        data: error.response.data
                    }, null, 2));
                }
                this.$message.error(error.response?.data?.message || error.message || '操作失败');
            }

        },
        handleImport() {
            this.importVisible = true
            this.selectedFile = null
        },
        handleFileChange(file) {
            this.selectedFile = file.raw;
        },
        handleExceed(files) {
            this.$refs.uploadRef.clearFiles();
            const file = files[0];
            this.$refs.uploadRef.handleStart(file);
            this.selectedFile = file;
        },
        async confirmImport() {
            if (!this.selectedFile) {
                this.$message.warning('请选择要导入的文件');
                return;
            }
            this.importLoading = true;
            try {
                const rules = await this.parseExcel(this.selectedFile);
                if (!rules || rules.length === 0) {
                    this.$message.error('Excel文件为空或格式不正确，请下载模板文件查看格式。');
                    return; // early return
                }

                // 为每一条导入的规则附加必要的参数
                const rulesWithContext = rules.map(rule => ({
                    ...rule,
                    userid: this.currentUserInfo.userId,
                    groupid: this.currentUserInfo.groupId,
                    userBot: this.currentUserInfo.userBot,
                }));

                const response = await api.importAutoReplyRules(rulesWithContext);
                if (response.data.code === 0) {
                    this.$message.success(`成功导入 ${response.data.data.importedCount} 条规则！`);
                    this.importVisible = false;
                    this.fetchData();
                } else {
                    this.$message.error(response.data.message || '导入失败');
                }
            } catch (error) {
                console.error('导入失败:', error);
                this.$message.error('导入失败，请检查文件格式或联系管理员。');
            } finally {
                this.importLoading = false;
            }
        },
        parseExcel(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = e => {
                    try {
                        const data = e.target.result;
                        const workbook = XLSX.read(data, { type: 'array' });
                        const firstSheetName = workbook.SheetNames[0];
                        const worksheet = workbook.Sheets[firstSheetName];
                        const json = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

                        // 跳过表头 (第一行)
                        const rows = json.slice(1);

                        const rules = rows.map(row => {
                            // 从 row[1] 开始映射，以忽略第一列 (ID)
                            return {
                                ruletype: row[1],
                                keyword: row[2],
                                replaytype: row[3],
                                mediaurl: row[4],
                                replaytext: row[5],
                                button: row[6],
                                buttonpaging: row[7],
                                noreply2admin: row[8],
                                quoteusermsg: row[9],
                                delreplymsg: row[10],
                                deloriginalmsg: row[11],
                                remark: row[12],
                                requiredpoints: row[13],
                                status: row[14],

                            };
                        }).filter(rule => rule.keyword && rule.keyword.trim() !== ''); // 过滤掉没有关键词的无效行

                        resolve(rules);
                    } catch (err) {
                        reject(err);
                    }
                };
                reader.readAsArrayBuffer(file);
            });
        },
        async handleExport() {
            try {
                this.loading = true

                // 获取所有数据 - 不分页
                const response = await api.getAutoReplyRules({
                    userid: this.currentUserInfo.userId,
                    groupid: this.currentUserInfo.groupId,
                    userBot: this.currentUserInfo.userBot,
                    page: 1,
                    pageSize: 10000 // 获取足够大的数量
                })

                if (response.data.code === 0) {
                    const rules = response.data.data.records || response.data.data
                    this.exportToExcel(rules)
                    this.$message.success('导出成功')
                } else {
                    this.$message.error(response.data.message || '获取数据失败')
                }
            } catch (error) {
                console.error('导出失败:', error)
                this.$message.error('导出失败')
            } finally {
                this.loading = false
            }
        },

        // 导出为Excel
        exportToExcel(rules) {
            const XLSX = window.XLSX || require('xlsx')

            // 数据转换映射函数
            const convertDataForExport = (rules) => {
                return rules.map((rule, index) => {
                    // 规则类型转换
                    let ruletypeText = '未知条件'
                    if (rule.ruletype === 0) ruletypeText = '等于'
                    else if (rule.ruletype === 1) ruletypeText = '包含'
                    else if (rule.ruletype === 2) ruletypeText = '正则表达式'

                    // 关键词处理 - 支持数组格式
                    let keywordText = ''
                    if (rule.keyword) {
                        try {
                            let keywords = []
                            if (typeof rule.keyword === 'string' && rule.keyword.startsWith('[')) {
                                keywords = JSON.parse(rule.keyword)
                            } else if (Array.isArray(rule.keyword)) {
                                keywords = rule.keyword
                            } else {
                                keywords = [rule.keyword]
                            }
                            keywordText = keywords.join(',')
                        } catch (e) {
                            keywordText = rule.keyword.toString()
                        }
                    }

                    // 回复类型转换
                    let replaytypeText = '文本内容'
                    if (rule.replaytype === 1) replaytypeText = '图片'
                    else if (rule.replaytype === 2) replaytypeText = '视频'

                    // 媒体URL处理
                    let mediaurlText = rule.mediaurl || ''

                    // 按钮处理 - 直接使用原始文本
                    let buttonText = rule.button || ''

                    // 按钮分页转换
                    let buttonpagingText = rule.buttonpaging === 1 ? '分页' : '不分页'

                    // 管理员回复转换
                    let noreply2adminText = rule.noreply2admin === 1 ? '是' : '否'

                    // 引用用户消息转换
                    let quoteusermsgText = rule.quoteusermsg === 1 ? '是' : '否'

                    // 删除回复消息转换
                    let delreplymsgText = '不删除'
                    if (rule.delreplymsg > 0) {
                        if (rule.delreplymsg < 60) {
                            delreplymsgText = `${rule.delreplymsg}秒后自动删除`
                        } else {
                            delreplymsgText = `${Math.floor(rule.delreplymsg / 60)}分后自动删除`
                        }
                    } else if (rule.delreplymsg === -1) {
                        delreplymsgText = '删除上一条'
                    }

                    // 删除原始消息转换
                    let deloriginalmsgText = '不删除'
                    if (rule.deloriginalmsg > 0) {
                        if (rule.deloriginalmsg < 60) {
                            deloriginalmsgText = `${rule.deloriginalmsg}秒后自动删除`
                        } else {
                            deloriginalmsgText = `${Math.floor(rule.deloriginalmsg / 60)}分后自动删除`
                        }
                    }

                    // 状态转换
                    let statusText = rule.status === 1 ? '是' : '否'

                    return {
                        'ID': index + 1,
                        '规则类型': ruletypeText,
                        '关键词': keywordText,
                        '回复类型': replaytypeText,
                        '媒体URL': mediaurlText,
                        '回复文本': rule.replaytext || '',
                        '按钮': buttonText,
                        '按钮分页': buttonpagingText,
                        '回复管理员消息': noreply2adminText,
                        '引用用户消息': quoteusermsgText,
                        '删除回复消息': delreplymsgText,
                        '删除原始消息': deloriginalmsgText,
                        '备注': rule.remark || '',
                        '所需积分': rule.requiredpoints || 0,
                        '状态': statusText
                    }
                })
            }

            // 转换数据
            const exportData = convertDataForExport(rules)

            // 创建工作表
            const ws = XLSX.utils.json_to_sheet(exportData)

            // 设置列宽
            const colWidths = [
                { wch: 5 },   // ID
                { wch: 12 },  // 规则类型
                { wch: 20 },  // 关键词
                { wch: 10 },  // 回复类型
                { wch: 30 },  // 媒体URL
                { wch: 40 },  // 回复文本
                { wch: 30 },  // 按钮
                { wch: 10 },  // 按钮分页
                { wch: 15 },  // 回复管理员消息
                { wch: 15 },  // 引用用户消息
                { wch: 15 },  // 删除回复消息
                { wch: 15 },  // 删除原始消息
                { wch: 20 },  // 备注
                { wch: 10 },  // 所需积分
                { wch: 8 }    // 状态
            ]
            ws['!cols'] = colWidths

            // 创建工作簿
            const wb = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(wb, ws, '自动回复规则')

            // 生成文件名
            const filename = `群自动回复_${new Date().toISOString().split('T')[0]}.xlsx`

            // 下载文件
            XLSX.writeFile(wb, filename)
        },
        getRuleDescription(rule) {
            const ruleTypeMap = {
                0: '等于',
                1: '包含',
                2: '正则匹配'
            };
            const typeName = ruleTypeMap[rule.ruletype] || '未知条件';

            // 处理关键词显示：支持数组和字符串格式
            let keywordDisplay = '';
            if (rule.keyword) {
                try {
                    let keywords = [];
                    if (typeof rule.keyword === 'string' && rule.keyword.startsWith('[')) {
                        // JSON数组字符串
                        keywords = JSON.parse(rule.keyword);
                    } else if (Array.isArray(rule.keyword)) {
                        // 已经是数组
                        keywords = rule.keyword;
                    } else {
                        // 逗号分隔的字符串
                        keywords = rule.keyword.split(',').filter(k => k.trim());
                    }

                    if (keywords.length > 1) {
                        keywordDisplay = keywords.join(' 或 ');
                    } else {
                        keywordDisplay = keywords[0] || rule.keyword;
                    }
                } catch (e) {
                    // 解析失败，直接使用原始值
                    keywordDisplay = rule.keyword;
                }
            } else {
                keywordDisplay = '无关键词';
            }

            return `当消息内容 ${typeName} " ${keywordDisplay} " 时`;
        },
        getReplayTypeName(replaytype) {
            const types = { 0: '文本', 1: '图片', 2: '视频' }
            return types[replaytype] || '未知'
        },
        getReplayTypeColor(replaytype) {
            const colors = { 0: 'primary', 1: 'success', 2: 'warning' }
            return colors[replaytype] || 'info'
        },
        formatDateTime(dateTime) {
            if (!dateTime) return '-'
            const date = new Date(dateTime)
            return date.toLocaleString('zh-CN')
        },
        async handlePreview(row) {
            try {
                this.$message.info('正在发送预览消息...')

                let buttons = this.parseButtonData(row.button || '')

                const response = await api.previewAutoReply({
                    userBot: row.userBot,
                    groupid: row.groupid,
                    userid: row.userid,
                    replaytype: row.replaytype,
                    mediaurl: row.mediaurl,
                    cdnurl: row.cdnurl,
                    replaytext: row.replaytext,
                    button: buttons,
                })

                if (response.data.code === 0) {
                    this.$message.success('预览消息发送成功！')
                } else {
                    this.$message.error(response.data.message || '预览发送失败')
                }
            } catch (error) {
                console.error('预览失败:', error)
                this.$message.error('预览发送失败，请检查机器人配置')
            }
        },
        async handlePreviewtemplate() {
            //////////把正在编辑的消息 发送给机器人 预览  数据从 this.form中读取
            try {
                this.$message.info('正在发送预览消息...')

                const response = await api.previewAutoReply({
                    userid: this.currentUserInfo.userId,
                    groupid: this.currentUserInfo.groupId,
                    userBot: this.currentUserInfo.userBot,
                    replaytype: this.form.replaytype,
                    mediaurl: this.form.mediaurl,
                    cdnurl: this.form.cdnurl || null,
                    replaytext: this.form.replaytext,
                    button: this.form.buttons,
                })


                if (response.data.code === 0) {
                    this.$message.success('预览消息发送成功！')
                } else {
                    this.$message.error(response.data.message || '预览发送失败')
                }
            } catch (error) {
                console.error('预览失败:', error)
                this.$message.error('临时预览发送失败')
            }

        },
        removeButtonRow(rowIndex) {
            this.form.buttons.splice(rowIndex, 1)
        },
        addButton(rowIndex) {
            this.form.buttons[rowIndex].push({ text: '', url: '' })
        },
        removeButton(rowIndex, btnIndex) {
            this.form.buttons[rowIndex].splice(btnIndex, 1)
            // 如果删除按钮后该行没有按钮了，则删除整行
            if (this.form.buttons[rowIndex].length === 0) {
                this.form.buttons.splice(rowIndex, 1)

                // 如果当前选中的行被删除了，重置状态
                if (this.currentRowIndex === rowIndex) {
                    this.currentRowIndex = -1
                }
                // 如果删除的行在当前选中行之前，需要调整索引
                else if (this.currentRowIndex > rowIndex) {
                    this.currentRowIndex--
                }
            }
        },
        editButton(rowIndex, btnIndex) {
            // 设置编辑状态
            this.editingButtonRowIndex = rowIndex
            this.editingButtonIndex = btnIndex
            this.currentRowIndex = rowIndex

            // 填充表单数据
            const button = this.form.buttons[rowIndex][btnIndex]
            this.buttonForm.text = button.text
            this.buttonForm.url = button.url

            // 显示对话框
            this.buttonDialogVisible = true
        },

        handleKeywordTagClose(tag) {
            this.form.keywords.splice(this.form.keywords.indexOf(tag), 1);
        },
        handleKeywordInputConfirm() {
            let inputValue = this.form.keyword_input.trim();
            if (inputValue && !this.form.keywords.includes(inputValue)) {
                this.form.keywords.push(inputValue);
            }
            this.form.keyword_input = '';
        },
        formatText(type) {
            const textarea = this.$refs.replaytextInput.$refs.textarea;
            if (!textarea) return;

            const start = textarea.selectionStart;
            const end = textarea.selectionEnd;
            const selectedText = this.form.replaytext.substring(start, end);
            let replacement = selectedText;
            let preSelection = 0;
            let postSelection = 0;

            switch (type) {
                case 'bold':
                    replacement = `**${selectedText}**`;
                    preSelection = 2;
                    postSelection = 2;
                    break;
                case 'italic':
                    replacement = `_${selectedText}_`;
                    preSelection = 1;
                    postSelection = 1;
                    break;
                case 'strikethrough':
                    replacement = `~${selectedText}~`;
                    preSelection = 1;
                    postSelection = 1;
                    break;
                case 'code':
                    replacement = `\`${selectedText}\``;
                    preSelection = 1;
                    postSelection = 1;
                    break;
                case 'link':
                    {
                        const url = prompt("请输入链接 URL:", "https://");
                        if (url) {
                            replacement = `[${selectedText}](${url})`;
                            preSelection = 1;
                            postSelection = url.length + 3 + (selectedText.length > 0 ? 0 : -selectedText.length);
                        } else {
                            return;
                        }
                        break;
                    }
            }

            this.form.replaytext = this.form.replaytext.substring(0, start) + replacement + this.form.replaytext.substring(end);

            this.$nextTick(() => {
                textarea.focus();
                if (selectedText.length === 0) {
                    const newCursorPos = start + preSelection;
                    textarea.setSelectionRange(newCursorPos, newCursorPos);
                } else {
                    const newStart = start + preSelection;
                    const newEnd = start + replacement.length - postSelection;
                    textarea.setSelectionRange(newStart, newEnd);
                }
            });
        },
        insertHtml(tag, closeTag) {
            if (this.isSourceMode) {
                // 源码模式：操作textarea
                const textarea = this.$refs.htmlTextarea.$refs.textarea;
                if (!textarea) return;

                const start = textarea.selectionStart;
                const end = textarea.selectionEnd;
                const selectedText = this.form.replaytext.substring(start, end);
                let replacement = selectedText;
                let preSelection = 0;
                let postSelection = 0;

                if (selectedText.length > 0) {
                    replacement = tag + selectedText + (closeTag || '');
                    preSelection = tag.length;
                    postSelection = (closeTag || '').length;
                } else {
                    replacement = tag + (closeTag || '');
                    preSelection = tag.length;
                }

                this.form.replaytext = this.form.replaytext.substring(0, start) + replacement + this.form.replaytext.substring(end);

                this.$nextTick(() => {
                    textarea.focus();
                    if (selectedText.length === 0) {
                        const newCursorPos = start + preSelection;
                        textarea.setSelectionRange(newCursorPos, newCursorPos);
                    } else {
                        const newStart = start + preSelection;
                        const newEnd = start + replacement.length - postSelection;
                        textarea.setSelectionRange(newStart, newEnd);
                    }
                });
            } else {
                // 可视化模式：使用document.execCommand
                const visualEditor = this.$refs.visualEditor;
                if (!visualEditor) return;

                visualEditor.focus();

                if (tag === '<br>') {
                    document.execCommand('insertHTML', false, '<br>');
                } else if (tag === '<b>') {
                    document.execCommand('bold', false, null);
                } else if (tag === '<i>') {
                    document.execCommand('italic', false, null);
                } else if (tag === '<u>') {
                    document.execCommand('underline', false, null);
                } else if (tag === '<h1>') {
                    document.execCommand('formatBlock', false, 'h1');
                } else if (tag === '<h2>') {
                    document.execCommand('formatBlock', false, 'h2');
                } else if (tag === '<ul><li>') {
                    document.execCommand('insertUnorderedList', false, null);
                } else if (tag === '<ol><li>') {
                    document.execCommand('insertOrderedList', false, null);
                }

                // 更新form数据
                this.form.replaytext = visualEditor.innerHTML;
            }
        },
        toggleMode() {
            this.isSourceMode = !this.isSourceMode;

            // 模式切换时同步内容
            if (!this.isSourceMode) {
                // 从源码模式切换到可视化模式
                this.$nextTick(() => {
                    this.setVisualEditorContent(this.form.replaytext);
                });
            }
        },
        // 保存光标位置
        saveCaretPosition() {
            const selection = window.getSelection();
            if (selection.rangeCount > 0) {
                const range = selection.getRangeAt(0);
                const preCaretRange = range.cloneRange();
                preCaretRange.selectNodeContents(this.$refs.visualEditor);
                preCaretRange.setEnd(range.endContainer, range.endOffset);
                return preCaretRange.toString().length;
            }
            return 0;
        },

        // 恢复光标位置
        restoreCaretPosition(caretPos) {
            const editor = this.$refs.visualEditor;
            if (!editor) return;

            const selection = window.getSelection();
            const range = document.createRange();

            let charIndex = 0;
            let nodeStack = [editor];
            let node, foundStart = false;

            while (!foundStart && (node = nodeStack.pop())) {
                if (node.nodeType === Node.TEXT_NODE) {
                    const nextCharIndex = charIndex + node.textContent.length;
                    if (caretPos >= charIndex && caretPos <= nextCharIndex) {
                        range.setStart(node, caretPos - charIndex);
                        range.setEnd(node, caretPos - charIndex);
                        foundStart = true;
                    }
                    charIndex = nextCharIndex;
                } else {
                    let i = node.childNodes.length;
                    while (i--) {
                        nodeStack.push(node.childNodes[i]);
                    }
                }
            }

            if (foundStart) {
                selection.removeAllRanges();
                selection.addRange(range);
            }
        },
        handleVisualInput(event) {
            // 如果正在输入中文，不更新内容
            if (this.isComposing) {
                return;
            }

            // 获取编辑器的HTML内容
            const content = event.target.innerHTML;

            // 清除之前的定时器
            if (this.updateTimer) {
                clearTimeout(this.updateTimer);
            }

            // 使用防抖更新，避免频繁触发响应式更新
            this.updateTimer = setTimeout(() => {
                if (content !== this.form.replaytext) {
                    this.form.replaytext = content;
                }
            }, 300); // 300ms防抖
        },
        handlePaste(event) {
            // 让浏览器处理粘贴，支持富文本粘贴
            // 不阻止默认行为，让contenteditable自然处理粘贴
            // 粘贴后会触发input事件，自动更新form.replaytext
        },
        handleCompositionStart(event) {
            // 中文输入开始
            this.isComposing = true;
        },
        handleCompositionEnd(event) {
            // 中文输入结束，更新内容
            this.isComposing = false;

            const content = event.target.innerHTML;

            // 清除之前的定时器
            if (this.updateTimer) {
                clearTimeout(this.updateTimer);
            }

            // 中文输入结束时立即更新
            if (content !== this.form.replaytext) {
                this.form.replaytext = content;
            }
        },
        handleKeydown(event) {
            // 让浏览器处理所有按键，包括回车
            // contenteditable会自动处理换行，我们只需要在input事件中更新数据
        },
        // 手动设置可视化编辑器内容
        setVisualEditorContent(content) {
            if (this.$refs.visualEditor && !this.isSourceMode) {
                this.$refs.visualEditor.innerHTML = content || '';
            }
        },
        // 显示添加按钮对话框
        showAddButtonDialog(rowIndex) {
            // 检查是否超过每行最大按钮数限制
            if (rowIndex !== -1 && this.form.buttons[rowIndex].length >= 5) {
                this.$message.warning('每一行最多允许5个按钮');
                return;
            }

            // 重置编辑状态
            this.editingButtonRowIndex = -1;
            this.editingButtonIndex = -1;

            this.currentRowIndex = rowIndex;
            this.buttonForm = {
                text: '',
                url: ''
            };
            this.buttonDialogVisible = true;
        },
        // 获取对话框标题
        getDialogTitle() {
            if (this.editingButtonIndex !== -1) {
                // 编辑模式
                const rowNum = this.editingButtonRowIndex + 1;
                const btnNum = this.editingButtonIndex + 1;
                return `编辑第${rowNum}行第${btnNum}个按钮`;
            } else if (this.currentRowIndex === -1) {
                return '新增一行按钮';
            } else {
                // 检查行是否存在，防止访问已删除的行
                if (this.form.buttons[this.currentRowIndex]) {
                    const rowNum = this.currentRowIndex + 1;
                    const btnNum = this.form.buttons[this.currentRowIndex].length + 1;
                    return `第${rowNum}行第${btnNum}个按钮`;
                } else {
                    return '新增一行按钮';
                }
            }
        },
        // 确认添加按钮
        confirmAddButton() {
            // 验证表单
            this.$refs.buttonFormRef.validate((valid) => {
                if (!valid) {
                    return;
                }

                const buttonData = {
                    text: this.buttonForm.text.trim(),
                    url: this.buttonForm.url.trim()
                };

                if (this.editingButtonIndex !== -1) {
                    // 编辑模式：更新现有按钮
                    this.form.buttons[this.editingButtonRowIndex][this.editingButtonIndex] = buttonData;
                    this.$message.success('按钮编辑成功');

                    // 重置编辑状态
                    this.editingButtonRowIndex = -1;
                    this.editingButtonIndex = -1;
                } else if (this.currentRowIndex === -1) {
                    // 新增一行按钮
                    this.form.buttons.push([buttonData]);
                    this.$message.success('按钮添加成功');
                } else {
                    // 在指定行添加按钮 - 检查行是否存在
                    if (this.form.buttons[this.currentRowIndex]) {
                        this.form.buttons[this.currentRowIndex].push(buttonData);
                        this.$message.success('按钮添加成功');
                    } else {
                        // 如果指定行不存在，创建新行
                        this.form.buttons.push([buttonData]);
                        this.$message.success('按钮添加成功');
                    }
                }

                this.buttonDialogVisible = false;
            });
        },

        // 拖拽相关方法
        handleDragStart(rowIndex) {
            this.draggedRowIndex = rowIndex;
        },

        handleDragEnd() {
            this.draggedRowIndex = null;
        },

        handleDragOver(event) {
            event.preventDefault();
        },

        handleDrop(event, targetRowIndex) {
            event.preventDefault();
            event.stopPropagation();

            if (this.draggedRowIndex === null || this.draggedRowIndex === targetRowIndex) {
                return;
            }

            const fromIndex = this.draggedRowIndex;
            const toIndex = targetRowIndex;


            // 移动按钮行 - 创建新数组强制响应式更新
            const newButtons = [...this.form.buttons];
            const draggedRow = newButtons[fromIndex];

            // 移除原位置的行
            newButtons.splice(fromIndex, 1);
            // 插入到新位置
            newButtons.splice(toIndex, 0, draggedRow);


            // 替换整个数组触发响应式更新
            this.form.buttons = newButtons;

            // 强制Vue重新渲染
            this.$nextTick(() => {
                this.$forceUpdate();
            });

            this.$message.success(`第${fromIndex + 1}行已移动到第${toIndex + 1}行`);
        },

        // 解析按钮文本数据为二维数组
        parseButtonData(buttonText) {
            if (!buttonText || typeof buttonText !== 'string') {
                return [];
            }

            try {
                // 1. 按换行符分割成行
                const lines = buttonText.split('\n').filter(line => line.trim());

                // 2. 每行按分号分割成按钮
                const buttons = lines.map(line => {
                    return line.split(';').filter(item => item.trim()).map(item => {
                        // 3. 解析每个按钮的文字和链接 格式: 文字(链接)
                        const match = item.trim().match(/^(.+?)\((.+?)\)$/);
                        if (match) {
                            return {
                                text: match[1].trim(),
                                url: match[2].trim()
                            };
                        }
                        return null;
                    }).filter(Boolean);
                }).filter(row => row.length > 0);

                return buttons;
            } catch (error) {
                console.error('解析按钮数据失败:', error);
                return [];
            }
        },
    },
    mounted() {
        if (this.$store.state.user) {
            this.loadUserInfo(this.$store.state.user);
            this.fetchData()
        }
    }
}
</script>

<style scoped>
.auto-reply {
    padding: 20px;
}

.search-section {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    margin-bottom: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.button-group {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
}

.stats-section {
    margin-bottom: 20px;
}

.stats-card {
    text-align: center;
}

.stats-item {
    padding: 10px;
}

.stats-value {
    font-size: 24px;
    font-weight: bold;
    color: #409eff;
    margin-bottom: 5px;
}

.stats-label {
    font-size: 14px;
    color: #666;
}

.keyword-display {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.keyword-desc {
    margin-top: 5px;
}

.reply-content {
    max-width: 300px;
    word-break: break-all;
}

.media-url {
    margin-top: 5px;
    padding: 5px;
    background: #f5f5f5;
    border-radius: 4px;
}

.advanced-settings {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.pagination {
    margin-top: 20px;
    text-align: center;
}

.dialog-footer {
    text-align: right;
}

.upload-demo {
    text-align: center;
}

.el-upload__tip {
    color: #666;
    font-size: 12px;
    margin-top: 10px;
}

.placeholder-description {
    font-size: 12px;
    color: #999;
    margin-top: 10px;
    line-height: 1.5;
}

.button-input-area {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding: 10px;
    min-height: 60px;
    margin-bottom: 10px;
}

.button-row {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
}

.button-item {
    display: flex;
    align-items: center;
    gap: 5px;
}

.button-controls {
    display: flex;
    gap: 10px;
}

.delete-row-btn {
    background-color: #fee;
    color: #f56c6c;
    border-color: #fde2e2;
}

.delete-row-btn:hover {
    background-color: #fdd;
    color: #f23c3c;
}

.other-settings {
    margin-top: 15px;
}

.setting-label {
    color: var(--el-text-color-regular);
    margin-right: 12px;
}

.form-label-with-icon {
    display: flex;
    align-items: center;
    gap: 4px;
}

.required-asterisk {
    color: var(--el-color-danger);
    margin-right: 4px;
}

.condition-input-group {
    display: flex;
    align-items: center;
    width: 100%;
    gap: 10px;
}

.reply-content-head {
    display: flex;
    align-items: flex-start;
}

.keyword-tags-input {
    flex-grow: 1;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 5px;
    border: 1px solid var(--el-border-color);
    border-radius: 4px;
    padding: 2px 8px;
    min-height: 32px;
    max-width: 350px;
}

.keyword-new-tag-input {
    border: none;
    outline: none;
    flex-grow: 1;
    min-width: 80px;
    background-color: transparent;
}

.html-editor {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    background: white;
    max-width: 460px;
}

.html-textarea {
    width: 100%;
    max-width: 460px;
}

.html-textarea :deep(.el-textarea__inner) {
    max-height: 200px;
    min-height: 120px;
    resize: vertical;
    word-wrap: break-word;
    overflow-wrap: break-word;
}

.html-toolbar {
    display: flex;
    align-items: center;
    padding: 8px 12px;
    border-bottom: 1px solid #dcdfe6;
    background: #f5f7fa;
    flex-wrap: wrap;
    gap: 4px;
}

.html-toolbar button {
    padding: 4px 8px;
    border: 1px solid #dcdfe6;
    background: white;
    border-radius: 3px;
    cursor: pointer;
    font-size: 12px;
    transition: all 0.2s;
    min-width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.html-toolbar button:hover:not(:disabled) {
    background: #ecf5ff;
    border-color: #409eff;
}

.html-toolbar button.is-active {
    background: #409eff;
    color: white;
    border-color: #409eff;
}

.html-toolbar button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background: #f5f7fa;
}

.html-toolbar .divider {
    margin: 0 8px;
    color: #dcdfe6;
}

.editor-content-area {
    border: 1px solid #dcdfe6;
    border-top: none;
    border-radius: 0 0 4px 4px;
}

.visual-editor {
    min-height: 50px;
    max-height: 200px;
    height: 200px;
    padding: 12px;
    outline: none;
    cursor: text;
    line-height: 1.6;
    font-size: 14px;
    background: white;
    border-radius: 0 0 4px 4px;
    direction: ltr;
    text-align: left;
    unicode-bidi: normal;
    overflow-y: auto;
    word-wrap: break-word;
    overflow-wrap: break-word;
    box-sizing: border-box;
}

.visual-editor:focus {
    outline: none;
}

.visual-editor p {
    margin: 8px 0;
}

.visual-editor p:first-child {
    margin-top: 0;
}

.visual-editor p:last-child {
    margin-bottom: 0;
}

.visual-editor h1,
.visual-editor h2,
.visual-editor h3 {
    margin: 16px 0 8px 0;
    font-weight: bold;
}

.visual-editor h1 {
    font-size: 1.5em;
}

.visual-editor h2 {
    font-size: 1.3em;
}

.visual-editor ul,
.visual-editor ol {
    padding-left: 20px;
    margin: 8px 0;
}

.visual-editor li {
    margin: 4px 0;
}

.visual-editor strong,
.visual-editor b {
    font-weight: bold;
}

.visual-editor em,
.visual-editor i {
    font-style: italic;
}

.visual-editor u {
    text-decoration: underline;
}

.visual-editor[contenteditable]:empty:before {
    content: "请输入回复内容...";
    color: #c0c4cc;
    font-style: italic;
}

.reply-type-horizontal {
    display: flex;
    align-items: center;
    gap: 20px;
    flex-wrap: nowrap;
}

.type-select-container {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    min-width: 250px;
}

.media-url-container {
    display: flex;
    align-items: center;
    gap: 10px;
    flex: 1;
    min-width: 350px;
    padding: 4px 8px;
    background-color: #f8f9fa;
    border-radius: 4px;
    border-left: 3px solid #409eff;
    animation: slideInRight 0.3s ease-out;
}

@keyframes slideInRight {
    from {
        opacity: 0;
        transform: translateX(20px);
    }

    to {
        opacity: 1;
        transform: translateX(0);
    }
}

.reply-type-dropdown {
    max-height: 200px;
    overflow-y: auto;
    z-index: 9999;
}

/* 按钮行列表样式 */
.button-rows-list {
    margin-bottom: 2px;
}

.button-row-wrapper {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-bottom: 2px;
    margin-left: 35px;
    /* 与新增一行按钮对齐 */
    border-radius: 6px;
    padding: 6px;
    transition: all 0.3s ease;
}

.button-row-wrapper.drag-over {
    background-color: #f0f9ff;
    border: 2px dashed #1890ff;
    transform: scale(1.02);
}

.gray-buttons-container {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: nowrap;
    /* 不允许换行 */
    width: 480px;
    /* 与新增一行按钮宽度一致 */
    flex-shrink: 0;
    /* 不允许收缩 */
}

.button-item {
    background: #a8a8a8;
    color: white;
    padding: 8px 16px;
    border-radius: 4px;
    font-size: 14px;
    text-align: center;
    border: none;
    cursor: default;
    white-space: nowrap;
    /* 文字不换行 */
    flex: 1;
    /* 弹性宽度，平均分配空间 */
    min-width: 0;
    /* 允许收缩到内容宽度 */
    overflow: hidden;
    /* 防止内容溢出 */
    text-overflow: ellipsis;
    /* 文字过长时显示省略号 */
    position: relative;
    /* 为操作按钮定位提供参考 */
    transition: all 0.3s ease;
    height: 36px;
    /* 确保与蓝色按钮高度一致 */
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
}

.button-item:hover {
    background: #909399;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.button-actions {
    position: absolute;
    top: 50%;
    right: 8px;
    transform: translateY(-50%);
    display: flex;
    gap: 4px;
    opacity: 0;
    transition: opacity 0.2s ease;
    z-index: 2;
}

.button-item:hover .button-actions {
    opacity: 1;
}

.button-action-icon {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
}

.edit-icon {
    background: #409eff;
}

.edit-icon:hover {
    background: #66b1ff;
    transform: scale(1.1);
}

.delete-icon {
    background: #f56c6c;
}

.delete-icon:hover {
    background: #f78989;
    transform: scale(1.1);
}

.button-action-icon .el-icon {
    font-size: 12px;
    color: white;
}

.add-button-container {
    display: flex;
    align-items: center;
    flex-shrink: 0;
}

.add-to-row-button {
    background: #1890ff;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    white-space: nowrap;
    transition: background-color 0.3s ease;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
}

.add-to-row-button:hover {
    background: #40a9ff;
}

/* 新增按钮样式 */
.button-controls {
    display: flex;
    align-items: center;
    padding: 0;
}

.add-row-button {
    border: 1px dashed #d9d9d9;
    background: #fff;
    color: #666;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.3s;
    outline: none;
    min-width: 480px;
    height: 36px;
    margin-left: 35px;
}

.add-row-button:hover {
    border-color: #1890ff;
    color: #1890ff;
}

.drag-icon-container {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    cursor: grab;
    user-select: none;
}

.drag-icon-container:active {
    cursor: grabbing;
}

.drag-icon {
    font-size: 16px;
    color: #8c8c8c;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: color 0.3s ease;
}

.drag-icon-container:hover .drag-icon {
    color: #1890ff;
}

.drag-icon-container[draggable="true"] {
    cursor: grab;
}

.drag-icon-container[draggable="true"]:active {
    cursor: grabbing;
}

/* 变量说明样式 */
.variable-help-text {
    margin-top: -10px;
    margin-bottom: 20px;
    margin-left: 120px;
    max-width: 430px;
    /* 与表单标签对齐 */
    padding: 12px 16px;
    background-color: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 6px;
    font-size: 13px;
    line-height: 1.6;
    color: #6c757d;
}

.variable-item {
    display: inline;
}

.variable-help-text code {
    background-color: #e3f2fd;
    color: #1976d2;
    padding: 2px 6px;
    border-radius: 3px;
    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
    font-size: 12px;
    font-weight: 600;
    border: 1px solid #bbdefb;
}
</style>